import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import AdminSideMenu from '../components/AdminSideMenu';
import AdminAppNavbar from '../components/AdminAppNavbar';
import AdminSideMenuMobile from '../components/AdminSideMenuMobile';
import { AdminLayoutProvider, useAdminLayoutContext } from '../components/AdminLayoutContext';
import { useAdminAuthSlice } from '../../../store/slices/adminAuth';
import { useAdminNotificationsSlice } from '../../notifications/slice';

function AdminLayoutContent() {
  const { scrollMode } = useAdminLayoutContext();
  const isViewportMode = scrollMode === 'viewport';

  return (
    <Box
      component="main"
      sx={(theme) => ({
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        minHeight: 0,
        height: { xs: '100dvh', md: '100vh' },
        overflow: isViewportMode ? 'hidden' : 'auto',
        WebkitOverflowScrolling: 'touch',
        overscrollBehavior: 'contain',
        backgroundColor: theme.vars
          ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
          : alpha(theme.palette.background.default, 1),
      })}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 1400,
          mx: 'auto',
          px: { xs: 2, sm: 3 },
          py: { xs: 10, md: 3 },
          ...(isViewportMode
            ? {
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
              }
            : {
                minHeight: '100%',
              }),
        }}
      >
        {isViewportMode ? (
          <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Outlet />
          </Box>
        ) : (
          <Outlet />
        )}
      </Box>
    </Box>
  );
}

export default function AdminLayout() {
  useAdminAuthSlice();
  useAdminNotificationsSlice();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <AdminLayoutProvider>
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        <AdminSideMenu />
        <AdminAppNavbar onMenuOpen={() => setMobileOpen(true)} />
        <AdminSideMenuMobile open={mobileOpen} onClose={() => setMobileOpen(false)} />
        <AdminLayoutContent />
      </Box>
    </AdminLayoutProvider>
  );
}
